import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenAuth } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenAuth';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenBasicInfo } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenBasicInfo';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenDetails } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenDetails';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMedia } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMedia';

export type GetExploreContent200PageAllOfThreeContentItemContentOneOfThreeseven = {
  /** 인증 컨텍스트 정보 */
  auth?: GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenAuth;
  basicInfo?: GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenBasicInfo;
  /** 토픽 상세 정보 */
  details?: GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenDetails;
  /** 미디어 정보 */
  media?: GetExploreContent200PageAllOfThreeContentItemContentOneOfThreesevenMedia;
};
